import { DASHBOARD_TEMPLATE_EMPTY } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";
import { FilterField } from "@/modules/DashboardTemplate/models/FilterOfCollection";
import { InnerLayoutItem } from "@/modules/DashboardTemplate/models/InnerLayoutItem";
import { PropertiesChart } from "@/modules/DashboardTemplate/models/PropertiesChart";
import {
  EventChart,
  SectionOfDashboard
} from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { DashboardSectionLayoutUpdate } from "@/modules/DashboardTemplate/models/SectionOfDashboardUpdateLocation";
import { FormsData } from "@/modules/Forms/models/FormsData";
import { ChatComunication } from "@/modules/Home/components/ChatWindow/Model/ChatComunication.model";
import { MedicalOrderPreviewEventTimelineModel } from "@/modules/MedicalOrder/models/MedicalOrderPreviewEventTimelineModel";
import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { SnackbarMessageStructure } from "@/shared/models/SnackbarMessageStructure";
import { Utils } from "@/shared/utils/utils";
import { cloneDeep } from "lodash";
import Vue from "vue";
import Vuex from "vuex";
import chatassistant from "./modules/chatassistant";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    onSession: false,
    userId: "",
    role: "",
    userName: "",
    avatar: "",
    panelView: false,
    dataToMainView: {} as MenuDataStructure,
    dataToLateralMenu: {} as MenuDataStructure,
    refreshProfileServices: true,
    taskRefreshing: false,
    notifications: [],
    snackbarMessage: {} as SnackbarMessageStructure,
    profileCrumbs: {} as MenuDataStructure,
    onChangeServiceValidation: false,
    refreshTemplateService: false,
    generalDataTasks: [] as FormsData[],
    dashBoardSearchName: "",
    refreshGroupService: false,
    campusServiceTemplate: false,
    callOrigin: "",
    userState: "",
    medicalOrderValidation: false,
    medicalOrderObjList: {} as MedicalOrderPreviewEventTimelineModel,
    chatComunication: {} as ChatComunication,
    groupsLevels: [],
    medicalOrderStates: [],
    constantsUI: {},
    eventData: {},
    sectionsOfDashboardStore: (cloneDeep(
      DASHBOARD_TEMPLATE_EMPTY
    ) as unknown) as Array<SectionOfDashboard>,
    refreshCharts: 0,
    triggerQuery: {
      trigger: 0,
      indexSectionOfDashboard: 0,
      indexCollectionFilter: 0
    },
    refreshTags: 0,
    refreshIndicators: 0,
    eventChart: {
      indexSection: 0,
      indexCollection: 0,
      values: "",
      chartType: "chartType"
    } as EventChart,
    sizeFilters: 0,
    loadSomethingInDashboard: false,
    actionInFilters: {
      indexSection: 0,
      indexCollection: 0,
      indexFilter: 0,
      field: ""
    },
    dataToUseInValuesSelect: [],
    loadingBqData: 0,
    showLoadingBar: false,
    totalFilters: 0,
    documentPathFromChat: ""
  },
  mutations: {
    changeSession(state, payload) {
      state.onSession = payload;
    },
    setUserId(state, payload) {
      state.userId = payload;
    },
    setPanelView(state, payload) {
      state.panelView = payload;
    },
    setRole(state, payload) {
      state.role = payload;
    },
    setEventData(state, payload) {
      state.eventData = payload;
    },
    setUserName(state, payload) {
      state.userName = payload;
    },
    setAvatar(state, payload) {
      state.avatar = payload;
    },
    setDataToMainView(state, payload) {
      state.dataToMainView = payload;
    },
    setDataToLateralMenu(state, payload) {
      state.dataToLateralMenu = payload;
    },
    setRefreshProfileServices(state) {
      state.refreshProfileServices = !state.refreshProfileServices;
    },
    setTaskRefreshing(state, payload) {
      state.taskRefreshing = payload;
    },
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setSnackbarMessage(state, payload) {
      state.snackbarMessage = payload;
    },
    setProfileCrumbs(state, payload) {
      state.profileCrumbs = payload;
    },
    setOnChangeServiceValidation(state, payload) {
      state.onChangeServiceValidation = payload;
    },
    setRefreshTemplateService(state, payload) {
      state.refreshTemplateService = payload;
    },
    setGeneralDataTasks(state, payload) {
      state.generalDataTasks = payload;
    },
    setDashBoardNameSearch(state, payload) {
      state.dashBoardSearchName = payload;
    },
    setGroupServiceRefresh(state, payload) {
      state.refreshGroupService = payload;
    },
    setCampusServiceTemplate(state, payload) {
      state.campusServiceTemplate = payload;
    },
    setCallOrigin(state, payload) {
      state.callOrigin = payload;
    },
    setUserState(state, payload) {
      state.userState = payload;
    },
    setMedicalOrderValidation(state, payload) {
      state.medicalOrderValidation = payload;
    },
    setMedicalOrderObjList(state, payload) {
      state.medicalOrderObjList = payload;
    },
    setChatComunication(state, payload) {
      state.chatComunication = payload;
    },
    setGroupsLevels(state, payload) {
      state.groupsLevels = payload;
    },
    setOrderStates(state, payload) {
      state.medicalOrderStates = payload;
    },
    setConstantsUI(state, payload) {
      state.constantsUI = payload;
    },
    setDocumentPathFromChat(state, payload) {
      state.documentPathFromChat = payload;
    },
    //--------------------sectionsOfDashBoard----------------------------
    reduceTotalFilters(state) {
      state.totalFilters = state.totalFilters - 1;
    },
    setTotalFilters(state, payload) {
      state.totalFilters = payload;
    },
    setSectionsOfDashboard(state, payload) {
      state.sectionsOfDashboardStore.push(payload);
    },
    updateSectionsOfDashboard(state, payload) {
      state.sectionsOfDashboardStore = payload;
      state.refreshCharts++;
    },
    setCollectionsOptions(state, payload) {
      state.sectionsOfDashboardStore[payload.index].collectionsOptions =
        payload.collectionsOptions;
    },
    updateSectionNameOfDashboard(state, payload) {
      state.sectionsOfDashboardStore[payload.index].name = payload.name;
    },
    addCollectionToSectionOfDashboard(state, payload) {
      state.sectionsOfDashboardStore[payload.index].collections.push(
        payload.collection
      );
    },
    addFilter(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.index].filters.push(payload.onefilter);
    },

    deleteSectionOfDashboard(state, payload) {
      state.sectionsOfDashboardStore.splice(payload, 1);
    },
    deleteCollection(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections.splice(payload.index, 1);
    },
    deleteFilter(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollection].filters.splice(
        payload.indexFilter,
        1
      );
    },
    quitCollectionItemOptionAndPutInCollection(state, payload) {
      if (
        state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
          .collections[payload.indexCollectionFilter].collection[0].id !== ""
      ) {
        state.sectionsOfDashboardStore[
          payload.indexSectionOfDashboard
        ].collectionsOptions = [
          ...state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
            .collectionsOptions,
          state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
            .collections[payload.indexCollectionFilter].collection[0]
        ];
      }

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].collection =
        payload.collection;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].filters = [];
    },
    deleteFieldInStore(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[
        payload.indexCollectionFilter
      ].filters = state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].filters.filter(
        item => (item.field[0] as FilterField)?.id !== payload.field
      );
    },
    setCollectionItem(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collectionsOptions.push(payload.collection);
    },
    setFilterItem(state, payload) {
      const existingFilter =
        state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
          .collections[payload.indexCollection].filters[payload.indexFilter];

      if (existingFilter?.value?.[0]?.fields && payload.filter?.value?.[0]) {
        (payload.filter.value[0] as any).fields =
          existingFilter.value[0].fields;
      }

      Vue.set(
        state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
          .collections[payload.indexCollection].filters,
        payload.indexFilter,
        payload.filter
      );
    },
    setEventChart(state, payload) {
      state.eventChart = payload;
    },
    setConfigChart(state, payload) {
      if (payload.notFound) {
        state.sectionsOfDashboardStore[
          payload.indexSectionOfDashboard
        ].collections[payload.indexCollectionFilter].chartData = {};
        state.refreshCharts++;
        return;
      }

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].groupBy = payload.groupBy;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].seeBy = payload.seeBy;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].rangeSize =
        payload.rangeSize;

      if (payload.chartName) {
        state.sectionsOfDashboardStore[
          payload.indexSectionOfDashboard
        ].collections[payload.indexCollectionFilter].chartName =
          payload.chartName;
      }

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].chartData =
        payload.chartData;

      if (payload.chartColor) {
        state.sectionsOfDashboardStore[
          payload.indexSectionOfDashboard
        ].collections[payload.indexCollectionFilter].chartColor =
          payload.chartColor;
      }

      if (payload.idQuery) {
        state.sectionsOfDashboardStore[
          payload.indexSectionOfDashboard
        ].collections[payload.indexCollectionFilter].idQuery = payload.idQuery;
      }

      state.refreshCharts++;
    },
    changeCollectionField(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].chartData = {};
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].groupBy = [];
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].seeBy = [];
      state.refreshCharts++;
      state.triggerQuery = {
        trigger: state.triggerQuery.trigger + 1,
        indexSectionOfDashboard: payload.indexSectionOfDashboard,
        indexCollectionFilter: payload.indexCollectionFilter
      };
    },
    cleanAllDataOfDashboardTemplate(state) {
      state.sectionsOfDashboardStore = (cloneDeep(
        DASHBOARD_TEMPLATE_EMPTY
      ) as unknown) as Array<SectionOfDashboard>;
    },
    addTag(state, payload) {
      state.sectionsOfDashboardStore[payload.indexSectionOfDashboard].tags.push(
        payload.tag
      );
      state.refreshTags++;
    },
    updateTag(state, payload) {
      const section =
        state.sectionsOfDashboardStore[payload.indexSectionOfDashboard];
      const currentTag = section.tags[payload.index];
      const newTag = payload.tag;

      if (JSON.stringify(currentTag) !== JSON.stringify(newTag)) {
        section.tags[payload.index] = newTag;
        state.refreshTags++;
      }
    },
    updateGroupBy(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].groupBy = payload.groupBy;
    },
    deleteTag(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].tags.splice(payload.index, 1);
      state.refreshTags++;
    },
    setTags(state, payload) {
      state.sectionsOfDashboardStore[payload.indexSectionOfDashboard].tags =
        payload.tags;
      state.refreshTags++;
    },
    addIndicator(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].indicators.push(payload.indicator);
      state.refreshIndicators++;
    },
    updateIndicator(state, payload) {
      const section =
        state.sectionsOfDashboardStore[payload.indexSectionOfDashboard];
      const currentIndicator = section.indicators[payload.index];
      const newIndicator = payload.indicator;

      if (JSON.stringify(currentIndicator) !== JSON.stringify(newIndicator)) {
        section.indicators[payload.index] = newIndicator;
        state.refreshIndicators++;
      }
    },
    deleteIndicator(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].indicators.splice(payload.index, 1);
      state.refreshIndicators++;
    },
    setIndicators(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].indicators = payload.indicators;
      state.refreshIndicators++;
    },
    setQuery(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].query = payload.query;
    },
    setFieldsToStore(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[
        payload.indexCollectionFilter
      ].collection[0].fields = cloneDeep(payload.fields);
      const collection = state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collectionsOptions.find(
        collection => collection.id === payload.collectionId
      );
      if (collection) {
        collection.fields = cloneDeep(payload.fields);
      }
    },
    updateLocations(
      state,
      { updateLocations }: { updateLocations: DashboardSectionLayoutUpdate[] }
    ) {
      state.sectionsOfDashboardStore.forEach(section => {
        const updateLocation = updateLocations.find(
          location => location.sectionName === section.name
        );
        if (updateLocation) {
          section.layout = updateLocation.layout;
          section.collections.forEach(collection => {
            const collectionLocation = updateLocation.propertiesToChart.find(
              prop =>
                prop.type == "chart" &&
                prop.name === collection.chartName &&
                collection.collection[0].id == prop.collection
            );
            if (collectionLocation && collectionLocation.type == "chart") {
              collection.layout = collectionLocation.layout;
              collection.chartType = collectionLocation.chartType;
            }
          });
          section.tags.forEach(tag => {
            const tagLocation = updateLocation.propertiesToChart.find(
              prop => prop.type == "tag" && prop.name === tag.indicatorOrTagName
            );
            if (tagLocation) {
              tag.layout = tagLocation.layout;
            }
          });

          section.indicators.forEach(indicator => {
            const indicatorLocation = updateLocation.propertiesToChart.find(
              prop =>
                prop.type == "indicator" &&
                prop.name === indicator.indicatorOrTagName
            );
            if (indicatorLocation) {
              indicator.layout = indicatorLocation.layout;
            }
          });
        }
      });
    },
    updateLocationsAndSizes(state, payload) {
      payload.forEach((item: InnerLayoutItem) => {
        if (item.type === "chart") {
          state.sectionsOfDashboardStore[
            (item.propertiesToChart as PropertiesChart).indexSectionOfDashboard
          ].collections[
            (item.propertiesToChart as PropertiesChart).indexCollectionFilter
          ].layout = {
            x: item.x,
            y: item.y,
            width: item.w,
            height: item.h
          };
        }
        if (item.type === "tag") {
          state.sectionsOfDashboardStore[item.indexSectionOfDashboard].tags[
            item.indexTag!
          ].layout = {
            x: item.x,
            y: item.y,
            width: item.w,
            height: item.h
          };
        }
        if (item.type === "indicator") {
          state.sectionsOfDashboardStore[
            item.indexSectionOfDashboard
          ].indicators[item.indexIndicator!].layout = {
            x: item.x,
            y: item.y,
            width: item.w,
            height: item.h
          };
        }
      });
    },
    updateSizesSection(state, payload) {
      state.sectionsOfDashboardStore[payload.indexSectionOfDashboard].layout = {
        x:
          state.sectionsOfDashboardStore[payload.indexSectionOfDashboard].layout
            ?.x || 0,
        y:
          state.sectionsOfDashboardStore[payload.indexSectionOfDashboard].layout
            ?.y || 0,
        width: payload.w,
        height: payload.h
      };
    },
    updateLocationsSection(state, payload) {
      payload.forEach((item: InnerLayoutItem) => {
        state.sectionsOfDashboardStore[parseInt(item.i)].layout = {
          width: item.w,
          height: item.h,
          x: item.x,
          y: item.y
        };
      });
    },
    setChartType(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].chartType =
        payload.chartType;
    },
    setLoadSomethingInDashboard(state, payload) {
      state.loadSomethingInDashboard = payload;
    },
    setActionInFilters(state, payload) {
      state.actionInFilters = payload;
    },
    setDataToUseInValuesSelect(state, payload) {
      // Si no existe el objeto para esta sección, crear uno vacío
      if (!state.dataToUseInValuesSelect[payload.indexSectionOfDashboard]) {
        Vue.set(
          state.dataToUseInValuesSelect,
          payload.indexSectionOfDashboard,
          {}
        );
      }

      const sectionData =
        state.dataToUseInValuesSelect[payload.indexSectionOfDashboard];

      // Si no existe la propiedad payload.id, crear el array
      if (!(sectionData as Record<string | number, unknown>)[payload.id]) {
        Vue.set(sectionData, payload.id, []);
      }

      // Asignar el dato
      (sectionData as Record<string | number, unknown>)[payload.id] =
        payload.data;
    },
    setFetchData(state, payload) {
      if (payload) {
        state.loadingBqData = state.loadingBqData + 1;
        if (state.loadingBqData === 1) {
          state.showLoadingBar = true;
        }
        return;
      }

      state.loadingBqData = state.loadingBqData - 1;
      if (state.loadingBqData === 0) {
        state.showLoadingBar = false;
        return;
      }
    },
    deleteChart(state, payload) {
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].chartData;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].groupBy;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].seeBy;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].rangeSize;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].chartName;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].chartColor;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].idQuery;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].query;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].chartType;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].layout;
      delete state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
        .collections[payload.indexCollectionFilter].chart;
    }
  },
  getters: {
    getDataToMainView: state => state.dataToMainView,
    getDataToLateralMenu: state => state.dataToLateralMenu,
    getRefreshProfileServices: state => state.refreshProfileServices,
    getPanelView: state => state.panelView,
    getTaskRefreshing: state => state.taskRefreshing,
    getNotifications: state => state.notifications,
    getSnackbarMessage: state => state.snackbarMessage,
    getProfileCrumbles: state => state.profileCrumbs,
    getOnChangeServiceValidation: state => state.onChangeServiceValidation,
    getRefreshTemplateService: state => state.refreshTemplateService,
    getGeneralDataTasks: state => state.generalDataTasks,
    getDashBoardNameSearch: state => state.dashBoardSearchName,
    getGroupServiceRefresh: state => state.refreshGroupService,
    getUserRole: state => state.role,
    getCampusServiceTemplate: state => state.campusServiceTemplate,
    getCallOrigin: state => state.callOrigin,
    getUserState: state => state.userState,
    getMedicalOrderValidation: state => state.medicalOrderValidation,
    getMedicalOrderObjList: state => state.medicalOrderObjList,
    getChatComunication: state => state.chatComunication,
    getGroupsLevels: state => state.groupsLevels,
    getOrderStates: state => state.medicalOrderStates,
    getDocumentPathFromChat: state => state.documentPathFromChat,

    //sectionsOfDashBoard
    getSectionsOfdashboard: state => state.sectionsOfDashboardStore,
    getLoadSomethingInDashboard: state => state.loadSomethingInDashboard,
    getActionInFilters: state => state.actionInFilters,
    getRefreshCharts: state => state.refreshCharts,
    getRefreshTags: state => state.refreshTags,
    getRefreshIndicators: state => state.refreshIndicators,
    getEventChart: state => state.eventChart,
    getSizeFilters: state => state.sizeFilters,
    getDataToUseInValuesSelect: state => state.dataToUseInValuesSelect,
    getShowLoadingBar: state => state.showLoadingBar,
    getTriggerQuery: state => state.triggerQuery,
    getTotalFilters: state => state.totalFilters,
    getEventData: state => state.eventData
  },
  actions: {
    async fetchConstantsUI({ commit }) {
      const constants = await Utils.getUIConfig();
      commit(STORE_CONSTANTS.SET_CONSTANTS_UI, constants);
    }
  },
  modules: {
    chatassistant
  }
});
